/*eslint-disable */
import appFooter from '../../components/footer/index';
import pubQuizinst from '../QuizInstruction/index';
import quizFinance from '../QuizFormatFinance/index';
import {
  mapGetters
} from 'vuex';
import {
  bus
} from '../../main';
var $ = window.jQuery = require('jquery');
import welcome from '../../components/welcome-popup/index';
import {
  Carousel,
  Slide
} from 'vue-carousel';
import Vue from 'vue'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)
// Multi Color Bg Img Of Section
import variation_random_img1 from './../../assets/images/mbl_random_img/mobile-devices-blue-hue-original.jpg';
import variation_random_img2 from './../../assets/images/mbl_random_img/Mobile-Devices-Green-Hue.jpg';
import variation_random_img3 from './../../assets/images/mbl_random_img/Mobile-Devices-Pink-Hue.jpg';
import variation_random_img4 from './../../assets/images/mbl_random_img/mobile-devices-yellow-hue.jpg';
var SliderDisabled;
export default {
  name: 'course-category',
  components: {
    Carousel,
    Slide,
    'app-footer': appFooter,
    'welcome-popup': welcome,
    'pub-quiz-ins':pubQuizinst,
    'quiz-finance': quizFinance
  },
  props: [],
  data() {
    return {
      courses: {},
      preloader: true,
      categoryParam: '',
      categoryName: '',
      backgroundImage: '',
      extralargeWrapper: false,
      courseBox: false,
      extralargeWrapperScreen: Boolean,
      window: {
        width: 0,
        height: 0
      },
      QuizzortPopupEnabled:false,
      QuizInstruction: false,
      QuizGameSpace: false,
      QuizGameCs: false,
      QuizGameFinance: false,
      QuizGameMachineLearing: false,
      QuizGameComputationalS: false,
      status: null,
      isBackgroundImg:Boolean,
    }
  },
  computed: {
    ...mapGetters([
      'getCourseCategoryGetter',
      'getCourseListGetter'
    ]),
    getCourseList() {
      //  console.log(this.$route.params);
      this.$store.dispatch('getCourseList', {
          id: this.$route.params.slug
        }).then((res) => {
          if (res.code == '2000') {
            // console.log(res);
            this.courses = this.$store.getters.getCourseListGetter.data.courses;
            this.categoryParam = this.$route.params.slug;
            this.isBackgroundImg = this.$store.getters.getCourseListGetter.data.bg_is_random
            this.categoryName = this.$store.getters.getCourseListGetter.data.name;
            if (this.$store.getters.getCourseListGetter.data.courses.length >= 5 && this.$store.getters.getCourseListGetter.data.courses.length <= 8) {
              this.extralargeWrapper = true;
              console.log(this.extralargeWrapper)
            }
            if (this.$store.getters.getCourseListGetter.data.courses.length >= 4) {
              this.courseBox = true;
              console.log(this.extralargeWrapper)
            }
            if (this.$store.getters.getCourseListGetter.data.courses.length <= 4) {
              this.extralargeWrapper = false;
              console.log(this.extralargeWrapper)
            }
              if(this.isBackgroundImg == true){
                // Multi Color Bg Img Of Section
                var variation_images = this.$store.getters.getCourseListGetter.data.background_images
                var size = variation_images.length;
                var x = Math.floor(size * Math.random());
                this.backgroundImage = variation_images[x].image
                console.log(this.backgroundImage)
              }else{
                this.backgroundImage = this.$store.getters.getCourseListGetter.data.bg_image;
              }
            this.preloader = false;
            // $('.app-loader').hide()
            document.title = ' Oddvega - ' + this.categoryName;
          }
        })
        .catch((err) => {
          //  console.log(err);
        })
    }
  },
  // Override the meta.
  metaInfo() {
    return {
      meta: [{
        name: 'description',
        content: this.categoryName + '.'
      }]
    }
  },
  mounted() {
    $('.app-loader').show()
    bus.$emit('hideHeaderbtn', false);
    bus.$emit('showHomeMenuBtn', true);
    bus.$emit('showQuizMenubtn', true);
    bus.$on('hideQuizzortPopupEnabled', (data) => {
      this.QuizzortPopupEnabled = data;
    });
    bus.$on('showQuizInstruction', (data) => {
      this.QuizInstruction = data;
    });
    bus.$on('showQuizGameFinance', (data) => {
      this.QuizGameFinance = data;
    });
    this.randomImgLoaded()
    setTimeout(() => {
      this.preloader = false;
      $('.app-loader').hide()
    }, 800);
    this.renderMathJax()
    $(document).ready(function(){
      setTimeout(() => {
        $('.explore_quiz_btn_wrp').addClass('actv_quiz')
      },100);
    })
    localStorage.removeItem('Explore_Course');
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
  },
  methods: {
    PubQuizStart(name){
      this.QuizzortPopupEnabled = true
      this.QuizInstruction = true
      setTimeout(() => {
        $(".quizzort_main_popup_wrp").addClass("popup_active");
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 100)
      $("body").addClass("quizzort_popup_active");
      $('.routeloader').addClass("searchLoaderhide")
      this.$store.dispatch('getPubQuizQuestionListFun', {slug:this.$route.params.slug} )
    },
    renderMathJax(){
      setTimeout(()=>{
        if(window.MathJax){
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log('done'));
        }
      },100)
    },
    randomImgLoaded() {
      // Multi Color Bg Img Of Section
      // debugger
      var images = ["random_img1", "random_img2", "random_img3", "random_img4"]
      var variation_images = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4]
      var size = images.length;
      var x = Math.floor(size * Math.random());
      var element = document.getElementsByClassName('mbl_random_img');
      console.log(x);
      // debugger
      if (x < images.length) {
        element[0].style["background-image"] = "url(" + variation_images[x] + ")";
        // debugger
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      if (this.window.width >= 992) {
        this.extralargeWrapperScreen = true;
        // debugger
      } else {
        this.extralargeWrapperScreen = false;
        // debugger
      }
    },
    scrollingToSection(section) {
      localStorage.setItem('Explore_Course', section);
      this.$router.push('/')
    },
  },
  beforeMount() {
    this.getCourseList;
  },
  beforeCreate: function() {
    $('body').addClass('category public-routes');
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('category public-routes');
    $('.routeloader').removeClass("searchLoaderhide")
    clearTimeout(SliderDisabled);
    next();
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch:{
    getCourseList(){
      this.renderMathJax()     
    }
  }
}